import { InvoicingConfig } from "@wingspanhq/wingspan-api-sdk";

/**
 * The invoicing config the payee's invoice form runs on for a client that has
 * none stored.
 *
 * `getInvoicingConfigForPayee` resolves real rules for a client that has them,
 * but a newly added client has none and nothing in the app creates one. The form
 * falls back to the most permissive shape: every optional field is shown to
 * everyone and nothing is forced, rather than hiding fields a payer may have
 * wanted or requiring ones they never asked for.
 *
 * Deliberate departures from `getDefaultInvoicingConfig` (the test fixture):
 * - `additionalGuidelines` off — the fixture carries sample copy, and there is
 *   no real per-client guideline text to show.
 */
export const getFallbackInvoicingConfig = (): InvoicingConfig => ({
  ...getDefaultInvoicingConfig(),
  additionalGuidelines: {
    enabled: false,
    value: ""
  }
});

export const getDefaultInvoicingConfig = (): InvoicingConfig => {
  return {
    allowOnlySelectedCurrencies: {
      //TODO: check if this is needed
      enabled: false,
      value: []
    },
    allowPayeeInitiatedInvoices: {
      enabled: true
    },
    additionalGuidelines: {
      enabled: true,
      value:
        "Client pays it's contractors on a monthly basis. Please submit your invoice by the 5th of the month to ensure timely payment."
    },
    allowOnlyPredefinedLineItems: {
      enabled: false,
      value: []
    },
    allowLineItemDiscounts: {
      enabled: true
    },
    allowLineItemReimbursableExpenses: {
      enabled: true
    },
    allowLateFees: {
      enabled: true
    },
    allowProcessingFeePercentage: {
      enabled: true
    },
    allowRecurringInvoices: {
      enabled: true
    },
    dueInDays: {
      enabled: false,
      value: 0
    },
    allowCollaboratorSplits: {
      enabled: true
    },
    requireAttachments: {
      enabled: false
    },
    requireProjectName: {
      enabled: false
    },
    requirePONumber: {
      enabled: false
    },
    allowPaymentReminders: {
      enabled: true
    }
  };
};
